import { MenuItem } from "../../../../../common/AppSidebar/types";
import { AppButton } from "../../../../../shared/components/AppButton";
import { AppCheckbox } from "../../../../../shared/components/AppCheckbox";
import styles from "./styles.module.css";

interface Props {
  item: MenuItem;
  fileType: "button" | "checkbox";
  onFileClick: (hash: string, fileName: string, isChecked?: boolean) => void;
  onFolderClick: (item: MenuItem) => void;
  isChecked?: boolean;
}

export const FileItem = ({
  item,
  fileType,
  onFileClick,
  onFolderClick,
  isChecked = false,
}: Props) => {
  const isFolder = !!item.children?.length;
  const isFile = !isFolder && !!item.value?.userfiles?.hash;

  const handleClick = () => {
    if (isFolder) {
      onFolderClick(item);
    } else if (isFile) {
      const hash = item.value.userfiles.hash;
      if (fileType === "checkbox") {
        const newCheckedState = !isChecked;
        onFileClick(hash, item.name, newCheckedState);
      } else {
        onFileClick(hash, item.name);
      }
    }
  };

  if (fileType === "button" || isFolder) {
    return (
      <AppButton
        buttonType={isFolder ? "outlined" : "text"}
        onClick={handleClick}
        className={styles["file-button"]}
      >
        {item.name}
      </AppButton>
    );
  }

  return (
    <AppCheckbox checked={isChecked} onClick={handleClick}>
      {item.name}
    </AppCheckbox>
  );
};
